import React, { useContext, createContext, useEffect, useCallback } from 'react'
import { useSelector } from 'react-redux'
import {
  selectGoal,
  selectGoalKey,
  selectTimeline,
  selectDesiredTimeline,
  selectProgressPercent,
  selectTrackerSectionInfo,
} from './ActionPlanSlice'

const ActionPlanContext = createContext()

export const useActionPlan = () => {
  return useContext(ActionPlanContext)
}

export const ActionPlanProvider = ({ s3_base_url, platformName, children }) => {
  const goal = useSelector(selectGoal)
  const goalKey = useSelector(selectGoalKey)
  const timeline = useSelector(selectTimeline)
  const desiredTimeline = useSelector(selectDesiredTimeline)
  const progressPercent = useSelector(selectProgressPercent)
  const trackerSectionInfo = useSelector(selectTrackerSectionInfo)

  const completionAnimationUrl =
    s3_base_url + '/articles/images/article-complete.gif'

  const cacheCompletionAnimation = useCallback(async () => {
    if (!s3_base_url || !completionAnimationUrl) return
    const completionAnimation = new Image()
    completionAnimation.src = completionAnimationUrl
  }, [completionAnimationUrl, s3_base_url])

  useEffect(() => {
    cacheCompletionAnimation()
  }, [cacheCompletionAnimation])

  const setConversationStarter = (starterSlug) => {
    window.conversationStarter = starterSlug
  }

  const value = {
    trackerSectionInfo,
    progressPercent,
    completionAnimationUrl,
    goal,
    goalKey,
    timeline,
    desiredTimeline,
    platformName,
    setConversationStarter,
  }

  return (
    <ActionPlanContext.Provider value={value}>
      {children}
    </ActionPlanContext.Provider>
  )
}
